import { Container } from 'ui/components';
import { Carousel } from 'ui/components/compounds/Carousel';
import { app } from 'core';
import Data from 'ui/components/primitives/Logo/Logo.data';
import { ResellerAvailableCatalogs } from 'core/services/bff';
import CycleGuideBotHeader from './CycleGuideBotHeader';
import CycleGuideBotSliderItem from './CycleGuideBotSliderItem';
import type { GuideComponent } from 'core/domains/content';

export const CycleGuideBot = ({
  catalogs,
  setOpenShareModal,
  setSelectedGuide,
}: GuideComponent) => {
  const isMobile = app.hooks.useApp('isMobile');

  const logoPath = (catalog: ResellerAvailableCatalogs) => {
    const logosData = Data as Record<string, { default: { paths: string[]; viewBox: string } }>;
    const majorBrands = { eudora: 'eud', boticario: 'bot' } as const;
    const brand = catalog?.brand?.toLowerCase() as keyof typeof majorBrands;
    const choosenbrand = logosData[majorBrands[brand]] || logosData[brand] || logosData['vdf'];
    return {
      paths: choosenbrand.default.paths,
      viewBox: choosenbrand.default.viewBox,
    };
  };

  return (
    <>
      <CycleGuideBotHeader />
      <Container fluid marginTop="sp-0" marginBottom="sp-2">
        <Carousel.Container
          container={true}
          desktop={!isMobile}
          dots
          itemsPerPage={{ desktop: 3, mobile: 1 }}
          navigationSize="sm"
          gaEvents={true}
        >
          {catalogs.map((catalog, i) => {
            const { viewBox, paths } = logoPath(catalog);
            const catalogWithPosition = {
              ...catalog,
              position: i + 1,
            } as ResellerAvailableCatalogs;
            return (
              <Carousel.Slide key={`${catalog?.name}`}>
                <CycleGuideBotSliderItem
                  catalogWithPosition={catalogWithPosition}
                  setOpenShareModal={setOpenShareModal}
                  setSelectedGuide={setSelectedGuide}
                  viewBox={viewBox}
                  paths={paths}
                />
              </Carousel.Slide>
            );
          })}
        </Carousel.Container>
      </Container>
    </>
  );
};

export default CycleGuideBot;
